<template>
    <draggable ref="draggable" v-bind="dragOptions" tag="div" class="item-container"
        :list="list" :value="value" @input="emitter">

        <div class="item-group" :key="element.id" v-for="(element, index) in value ? value : list">
            <div class="item">
                <v-icon v-show="level == null" @click="expandOrColapseNode(element.id)">{{element.isOpen ? "mdi-chevron-up" : "mdi-chevron-down"}}</v-icon>
                
                <span class="level">{{ `(${returnLevel(index + 1)})` }}</span>
                <span class="description">{{ element.description }}</span>

                <div class="action">
                    <v-icon @click="$router.push(`/controle-acesso/menu/adicionar?parentId=${element.id}`)" :color="Themes.primary" v-show="returnLevel(index + 1).split('.').length != 3">mdi-plus</v-icon>
                    <v-icon @click="$router.push(`/controle-acesso/menu/editar/${element.id}`)" :color="Themes.primary">mdi-pencil</v-icon>
                </div>
            </div>

            <menu-object :class="`${element.isOpen || level != null ? 'item-sub' : 'item-sub-hidden'}`" :list="element.child" :level="returnLevel(index + 1)" />
        </div>
    </draggable>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import VueDraggable from 'vuedraggable'
import Themes from '@/plugins/theme'

export default {
    name: "menu-object",
    mixins: [ FormMixin, DateMixin ],  
    props: {
        value: {
            required: false,
            type: Array,
            default: null
        },
        list: {
            required: false,
            type: Array,
            default: null
        },
        level:{
            required: false,
            type: String
        }
    },   
    data(){
        return {
            Themes: Themes
        }
    },
    components: {
        "draggable": VueDraggable
    }, 
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "parentObject",
                disabled: false,
                ghostClass: "ghost"
            };
        },

    },
    methods: {
        emitter(value) {
            this.$emit("input", value);
        },
        returnLevel(index){
            if(this.level == null)
                return new String(index);

            else
                return `${this.level}.${index}`;                
        },        
        expandOrColapseNode(id){
            let clone = this.$_.clone(this.value);
            let setNode = (id, parentNode) => {
                let list = null;
                if(parentNode == null)
                    list = clone;

                else 
                    list = parentNode.child;                    

                for(let i = 0; i < list.length; i++){
                    let node = list[i];
                    if(node.id == id){
                        if(node.isOpen == true)
                            node.isOpen = false; 
                        else 
                            node.isOpen = true; 

                        break;
                    }
                    else if(node.child != null && node.child.length > 0){
                        setNode(id, node);
                    }
                }
            }

            setNode(id, null);
            this.$emit("input", clone);            
        }
    },    
};
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

.item-container {
    margin: 0;
}

.item {
    padding: 20px;
    border: solid $blue-sonda 1px;
    background-color: $white;

    .v-icon{
        margin-right: 10px;
    }

    .level{
        padding-right: 10px;
    }    
}

.item-sub {
    margin: 0 0 0 50px;
}

.item-sub-hidden {
    margin: 0 0 0 50px;
    display: none;
}

.action {
    float: right;
}
</style>
